<script lang="ts">
  import { defineComponent } from "vue";
  import FicheTransactionCaisse from '@/generated/fiches/FicheTransactionCaisse.vue';
  export default defineComponent({
    extends: FicheTransactionCaisse,
    components: {}
})
</script>
